export const BUFFERING_DELAY_MS = 300;
export const DURATION_POLL_INTERVAL_MS = 250;
export const DURATION_POLL_MAX_MS = 5 * 60 * 1000;
export const VOLUME_WRITE_DELAY_MS = 150;
export const VOLUME_STEP = 0.5;
// Nova sizes assume a 16px root; ours is pinned to 10px, so scale like nova-rem() in the SCSS
export const THUMB_RADIUS_REM = 0.3125 * 1.6;
export const HAVE_METADATA = 1;
export const DEFAULT_RATE = 1;

// Player-level keyboard shortcuts (see shortcuts.js)
export const IGNORED_TARGET = '[role="listbox"], [role="menu"], input:not([type="range"]), textarea, select, [contenteditable="true"]';
export const SLIDER_TARGET = 'input[type="range"], [role="slider"]';
export const SPACE_IGNORED_TARGET = 'button, [role="option"]';
export const ERROR_ALLOWED_KEYS = ["ArrowUp", "ArrowDown", "m", "M"];
